import APIClient from '@/shared/http/clients/api'

const resourceName = 'perfilgrupo'
const APICore = process.env.APIBaseURLCore

const GetAllByGroupId = (groupID, data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/${groupID}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const GroupProfileRepository = {

  GetAllByGroupId,
  Create,
  Update,
  Delete
}

export default GroupProfileRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/groupprofile.js